import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/models/appConfig';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {

static appSettings: AppConfig

constructor(private http: HttpClient) { }

loadSettings() {
  const jsonFile = './assets/appsettings.json';
  return new Promise<void>((resolve, reject) => {
    this.http.get(jsonFile).toPromise().then((response: AppConfig) => {
       AppSettingsService.appSettings = <AppConfig>response;
       resolve();
    }).catch((response: any) => {
       reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
    });
  });
}


}


